import React from 'react'

interface TodayIconProps {
  size?: number
  className?: string
}

/**
 * Outlined calendar icon used as the "Jump to today" affordance in the
 * Upcoming MonthSelector. Stroke inherits `currentColor`.
 */
export const TodayIcon: React.FC<TodayIconProps> = ({ size = 16, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M5.33 1.33V4M10.67 1.33V4M2 6.67H14M3.33 2.67H12.67C13.4 2.67 14 3.26 14 4V13.33C14 14.07 13.4 14.67 12.67 14.67H3.33C2.6 14.67 2 14.07 2 13.33V4C2 3.26 2.6 2.67 3.33 2.67Z"
      stroke="currentColor"
      strokeWidth="1.33"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
